export default class DataList {

    constructor() {
        this.actualSelectedRowIndex = 1;
        this.lastRow = 0;
        this.listItems = [];
        this.wrapAround = false;
    }

    getActualSelectedRowIndex() {
        return this.actualSelectedRowIndex;
    }

    getSelectedItem() {
        if (this.actualSelectedRowIndex) {
            return this.listItems[this.actualSelectedRowIndex - 1];
        }

        return null;
    }

    selectRowAtIndex(index) {
        this.actualSelectedRowIndex = index;
    }

    getWrapAround() {
        return this.wrapAround;
    }

    setWrapAround(wrap) {
        this.wrapAround = wrap;            
    }

    selectNext() {
        if (this.isSelectedAtLast() && this.getWrapAround()) {
            this.selectRowAtIndex(1);

        } 
        else if (!this.isSelectedAtLast()) {
            this.actualSelectedRowIndex++;
        }
    }

    selectPrevious() {
		if (this.isSelectedAtFirst() && this.getWrapAround()) {
			this.selectRowAtIndex(this.lastRow);
        } 
        else if (!this.isSelectedAtFirst()) {
			this.actualSelectedRowIndex--;
		}
    }
    
	selectFirstItem () {
		this.selectRowAtIndex(1);
    }

    selectLastItem() {
		this.selectRowAtIndex(this.getSize());
	}
    
    getRowAtIndex(index) {
        if (this.getWrapAround() && (index < 1 || index > this.getSize())) {
			if (index < 1) {
				index = this.getSize() + (index % this.getSize());
            } 
            else {
				index = (index % this.getSize());
				index = index < 1 ? this.getSize() : index;
			}
        }
        
        return this.listItems[index - 1];
    }

    getSizeForRow(idx) {
        let row = this.getRowAtIndex(idx);
        if(row) {
            return row.length;
        }

        return 0;
    }
    
    getSize() {
		return this.lastRow;
    }
    
    isEmpty() {
		return (this.lastRow === 0);
	}

    isSelectedAtFirst() {
		return (this.actualSelectedRowIndex === 1 || this.lastRow === 0);
    }

    isSelectedAtLast() {
		return (this.actualSelectedRowIndex === this.lastRow || this.lastRow === 0);
	}

    loadData (data) {
		this.actualSelectedRowIndex = 1;
		this.lastRow = data.length;
	    this.listItems = data;
	}

    getData() {
		return this.listItems;
    }
    
    clear() {
		this.actualSelectedRowIndex = 1;
		this.lastRow = 0;
		this.listItems.length = 0;
    }
}


// WEBPACK FOOTER //
// ./src/AAF/Nepg/DataList.js